class Timer {
  constructor() {
    this.timer = null;
  }

  debounce(func, ms) {
    if (this.timer) {
      clearTimeout(this.timer);
    }

    this.timer = setTimeout(func, ms);
  }
}

export default Timer;
